import { inject, Injectable, Signal, signal, WritableSignal } from '@angular/core';
import {
  DashboardClient,
  LastEquipmentEventResponse,
} from '../../../../core/openapi/bff-admin-api';
import { catchError, defer, finalize, map, Observable, of } from 'rxjs';
import { IEquipmentEvent } from './last-equipment-events.model';
import { LoadingState } from '../../../../shared/types/loading.type';
import { ToastService } from '@ui-lib/components';
import { TranslateService } from '@ngx-translate/core';
import { outputError } from '../../../../shared/utils/output-error.function';

@Injectable()
export class LastEquipmentEventsService {
  private readonly dashboardClient = inject(DashboardClient);
  private readonly toastService = inject(ToastService);
  private readonly translateService = inject(TranslateService);

  private readonly _loadingStatus: WritableSignal<LoadingState> = signal<LoadingState>(
    LoadingState.IDLE,
  );
  public readonly loadingStatus: Signal<LoadingState> = this._loadingStatus.asReadonly();

  public readonly events$: Observable<IEquipmentEvent[]> = defer(() => {
    this._loadingStatus.set(LoadingState.LOADING);
    return this.dashboardClient.v1DashboardLastEquipmentEventsGet();
  }).pipe(
    map((events: LastEquipmentEventResponse[]) =>
      events.map<IEquipmentEvent>((event) => ({
        ...event,
        isUnknownWorker: !event.workerName,
      })),
    ),
    catchError((error) => {
      this.toastService.error({
        message: this.translateService.instant(
          'monitoring.dashboard.events.toast.fetching-failed',
          { error: outputError(error, this.translateService.instant('errors.unknown')) },
        ),
      });
      return of([]);
    }),
    finalize(() => this._loadingStatus.set(LoadingState.READY)),
  );
}
